import i18n from '../i18n/config';

/**
 * Utility function to translate tier names from English to the current language
 */
export const translateTierName = (tierName: string) => {
  if (!tierName) return '';

  const normalizedTierName = tierName.toLowerCase();

  switch (normalizedTierName) {
    case 'entry':
      return i18n.t('tiers.entry');
    case 'bronze':
      return i18n.t('tiers.bronze');
    case 'silver':
      return i18n.t('tiers.silver');
    case 'gold':
      return i18n.t('tiers.gold');
    case 'diamond':
      return i18n.t('tiers.diamond');
    case 'emerald':
      return i18n.t('tiers.emerald');
    case 'pearl':
      return i18n.t('tiers.pearl');
    case 'dynasty':
      return i18n.t('tiers.dynasty');
    default:
      // Fallback to original name if no translation found
      return tierName;
  }
};
